import React, {useState} from 'react';
import {makeStyles} from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import Person from "./Person";
import Dialog from "@material-ui/core/Dialog";
import Button from "@material-ui/core/Button";
import {Container, Row, Col} from 'reactstrap';
import './TeamSessionStyle.css'
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CloseIcon from "@material-ui/icons/Close";
import IconButton from "@material-ui/core/IconButton";
import Chart from "react-google-charts";
import DropItem from "./drop-item";
import DragItem from "./drag-item";

const useStyles = makeStyles(theme => ({

    card: {
        display: 'flex',
        height: '33%',
        boxShadow: '0px 4px 19px rgba(34, 121, 252, 0.2)',
        marginTop: '3vh',
    },
    personsPart: {
        display: 'flex',
        flexDirection: 'column',
        width: '90vw',
        background: '#D4EEFF',
    },
    content: {
        width: '100%',
        flex: '1 0 auto',
        padding: '0',
    },
    classSection: {
        width: '10%',
        background: '#2279FC',
    },
    personsTitle: {
        textAlign: 'right',
        fontSize: '24px',
        lineHeight: '28px',
        margin: '0',
        marginRight: '1vw',
    },
    TitlesPart: {
        textAlign: 'center',
        height: '80%',
        margin: '0',
    },
    classInfo: {
        height: '20%',
        width: '100%',
        background: 'linear-gradient(180deg, rgba(120, 174, 255, 0.4) 0%, rgba(240, 249, 255, 0.4) 133.12%)',
        boxShadow: '0px 4px 10px rgba(34, 121, 252, 0.2)',
        borderRadius: '0',

    },
    infoDialogText: {
        textAlign: 'center',
        padding: '0 30px 30px',
    },
    classNumberTitle: {
        margin: '0',
        fontSize: '80px',
        lineHeight: '95px',
        fontWeight: 'bold',
    },
    classTitle: {
        fontSize: '26px',
        lineHeight: '31px',
        margin: '0',
        fontWeight: 'bold',
        // paddingTop: '25%',
    },
    appBar: {
        background: "#D4EEFF",
        boxShadow: "0px 0px 20px rgba(110, 132, 188, 0.22), 0px 0px 4px rgba(0, 0, 0, 0.12)",
        transition: theme.transitions.create(['margin', 'width'], {
            easing: theme.transitions.easing.sharp,
            duration: theme.transitions.duration.leavingScreen,
        }),
    },
    appBarTitle: {
        fontFamily: "Roboto",
        fontStyle: "normal",
        fontWeight: "bold",
        fontSize: "32px",
        textTransform: "uppercase",
        color: "black",
    },
    chosenButton: {
        backgroundColor: 'rgb(140, 209, 255)',
        marginRight:
            theme.spacing(3),
    },
    menuItem: {
        marginRight: theme.spacing(3),
    },
    containerDrop: {
        display: "flex",
        flexDirection: "column",
        width: "100%",
        background: "#D4EEFF",
    },
}));

export default function TeamSessionComponent({inputChosenCategories, teamData, sessionsId, highlightAcquaintances, acquaintancesIds, callbackShowToast, callbackShowErrorToast}) {
    const classes = useStyles();
    // const theme = useTheme();

    const [isInfoDialogOpen, setIsInfoDialogOpen] = useState(false);
    const [isCandidatesStat, setIsCandidatesStat] = useState(true);
    const [statData, setStatData] = useState(teamData.stats.candidates);
    const [showDialog, setShowDialog] = useState(false);

    // Return false if every filter menu is with none value, otherwise return true. With this function we calc
    // only once if something should be highlighted (instead of calc this in every person rendering)
    const calcHasFilter = () => {
        if (inputChosenCategories) {
            for (let i = 0; i < Object.keys(inputChosenCategories).length; i++) {
                // there is only one key which is the category name.
                // debugger;
                const category = Object.keys(inputChosenCategories)[i];
                if (inputChosenCategories[category] !== 'none') {
                    return true;
                }
            }
            return false;
        } else {
            return false;
        }
    };

    const calcData = (category) => {
        var data = [["Stat", "Graph"]];
        category.categoryOptions.forEach((option) => {
            data.push([option.displayName, option.count]);
        });
        return data;
    };

    const options = {
        title: "",
        pieHole: 0.4,
        is3D: false
    };

    const submitEdit = async (peopleToEdit) => {
        const formData = new FormData();
        formData.append('peopleChanges', JSON.stringify(peopleToEdit));
        const getTeamsUrl = process.env.REACT_APP_BACKEND_URL + "/sessions/edit/" + sessionsId;
        try {
            const res = await fetch(getTeamsUrl, {
                method: 'POST',
                credentials: 'include',
                headers: {
                    'Accept': 'application/json',
                },
                body: formData
            })
            if (res.status === 401) {
                window.location.replace(process.env.REACT_APP_URL)
            }
            let data = await res.json();

            if (data.status === "Success" || data.status === "No Changes") {
                if (data.status === "Success") {
                    callbackShowToast();
                }
            } else {
                callbackShowErrorToast("ארעה שגיאה לא צפויה, נסו שנית במועד מאוחר יותר ");
            }
        }
        catch(error) {
            callbackShowErrorToast("ארעה שגיאה לא צפויה, נסו שנית במועד מאוחר יותר ");
        }
    };

    return (
        <Card className={classes.card}>
            <DropItem onDrop={id => {
                let peopleToEdit = [{
                    "person_id": id,
                    "exercisesClass": teamData.id
                }];
                submitEdit(peopleToEdit);
            }} claaName={classes.containerDrop}>
                <CardContent className={classes.content} style={{padding:'0'}}>
                    <Container className={classes.containerDrop} style={{display: 'grid'}}>
                        {/*<div>*/}
                        <Row>
                            <h4 className={classes.personsTitle}>מועמדים</h4></Row>
                        <Row>
                            {teamData.candidates.map((person, index) => {
                                return <Col key={index}><DragItem data=<Person person={person}
                                                      chosenCategories={inputChosenCategories}
                                                      hasFilter={calcHasFilter(inputChosenCategories)}
                                                      acquaintancesCallback={highlightAcquaintances}
                                                      acquaintancesIds={acquaintancesIds}
                                                      isTeamPerson={true}
                                                      classId={teamData.id}
                                                      sessionsId={sessionsId}
                                                      isInterviewPage={false} callbackShowToast={callbackShowToast}
                                                      callbackShowErrorToast={callbackShowErrorToast}/> id={person.id} key={person.id} />
                                </Col>
                            })}
                        </Row>
                        {/*</div>*/}
                        <div>
                            <Row>
                                <h4 className={classes.personsTitle}>מעריכים</h4></Row>
                            <Row>
                                {teamData.reviewers.map((person, index) => {
                                    return <Col key={index}><DragItem data=<Person key={index} person={person}
                                                          chosenCategories={inputChosenCategories}
                                                          hasFilter={calcHasFilter(inputChosenCategories)}
                                                          acquaintancesCallback={highlightAcquaintances}
                                                          acquaintancesIds={acquaintancesIds}
                                                          classId={teamData.id}
                                                          sessionsId={sessionsId}
                                                          isInterviewPage={false}
                                                          callbackShowToast={callbackShowToast}
                                                          callbackShowErrorToast={callbackShowErrorToast}/> id={person.id} key={person.id} /></Col>
                                })}
                            </Row>
                        </div>
                    </Container>
                </CardContent>
            </DropItem>
            <div className={classes.classSection}>
                <div className={classes.TitlesPart}>
                    <div style={{height:'10%'}}></div>
                    <h2 className={classes.classTitle}>כיתה</h2>
                    <h1 className={classes.classNumberTitle}>{teamData.id}</h1>
                </div>
                <Button className={classes.classInfo} onClick={() => {
                    setIsInfoDialogOpen(true);
                    const timer = setTimeout(() => {
                        // for the first render (wait for loading)
                        setShowDialog(true);
                    }, 1000);
                    return () => clearTimeout(timer);
                }}>
                    ניתוח כיתה</Button>
            </div>
            <Dialog fullScreen open={isInfoDialogOpen} style={{display: showDialog ? 'block' : 'none'}} onClose={() => {
                setIsInfoDialogOpen(false);
            }}>
                <div className={classes.infoDialogText}>
                    <AppBar
                        position="static"
                        className={classes.appBar}
                        style={{direction: "rtl"}}
                    >
                        <Toolbar>
                            <Typography variant="h6" className={classes.appBarTitle}>
                                ניתוח כיתה
                            </Typography>
                            <Button className={isCandidatesStat ? classes.chosenButton : classes.menuItem}
                                    onClick={() => {
                                        setIsCandidatesStat(true);
                                        setStatData(teamData.stats.candidates);
                                    }}>
                                מועמדים
                            </Button>
                            <Button className={isCandidatesStat ? classes.menuItem : classes.chosenButton}
                                    onClick={() => {
                                        setIsCandidatesStat(false);
                                        setStatData(teamData.stats.reviewers);
                                    }}>
                                מעריכים
                            </Button>
                            <div style={{flexGrow: 5}}/>
                            <IconButton color="inherit" onClick={() => {
                                setIsInfoDialogOpen(false)
                            }}> <CloseIcon style={{color: 'black'}}/></IconButton>
                        </Toolbar>

                    </AppBar>
                    {statData.map((category, i) => {
                        return <div key={i}>
                            <div className="StatsInfo">
                                {category.categoryName}
                            </div>
                            <Chart
                                chartType="PieChart"
                                width="100%"
                                height="400px"
                                data={calcData(category)}
                                options={options}
                            /></div>

                    })}
                </div>
            </Dialog>
        </Card>


    )
        ;
}
